import { useState, type FC } from "react";
import ConsentForm from "./components/ConsentForm";
import ConsentRequired from "./components/ConsentRequired";
import ConsentSuccess from "./components/ConsentSuccess";

const KemConsentPage: FC = () => {
  const [step, setStep] = useState(1);
  const renderStep = () => {
    switch (step) {
      case 1:
        return <ConsentRequired onAuthenticate={() => setStep(2)} />;
      case 2:
        return <ConsentForm onSuccess={() => setStep(3)} />;
      case 3:
        return <ConsentSuccess />;
      default:
        return <ConsentRequired onAuthenticate={() => setStep(2)} />;
    }
  };

  return (
    <div className="flex h-full w-full items-center justify-center">
      {renderStep()}
    </div>
  );
};

export default KemConsentPage;
